var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('app-drawer'),_c('v-main',[_c('v-container',{staticClass:"p-5 m-0",attrs:{"fluid":""}},[_c('snackbar'),_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }